import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/home",
  },
  { path: "/home", name: "home", component: () => import("@/views/home/Home"), meta: { title: "清明节，来用“AI”写首诗", keepAlive: true } },
];

const router = new VueRouter({
  routes,
  mode: "hash",
  base: process.env.VUE_BASE_URL,
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export default router;
